"use strict"; // Sh**t! I Smoke
// Copyright (C) 2018-2020  Marcelo S. Coelho, Amaury Martiny

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;
exports.Cigarettes = void 0; // Sh**t! I Smoke is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
// Sh**t! I Smoke is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
// You should have received a copy of the GNU General Public License
// along with Sh**t! I Smoke.  If not, see <http://www.gnu.org/licenses/>.

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var Cigarette_1 = require("./Cigarette");

var api_1 = require("../util/api");

var styles = react_native_1.StyleSheet.create({
  innerContainer: {
    alignContent: 'flex-end',
    alignItems: 'flex-end',
    flexDirection: 'row',
    flexWrap: 'wrap'
  }
});

function Cigarettes(props) {
  var realCigarettes = props.cigarettes,
      cigaretteStyle = props.cigaretteStyle,
      _a = props.fullCigaretteLength,
      fullCigaretteLength = _a === void 0 ? 90 : _a,
      _b = props.showMaxCigarettes,
      showMaxCigarettes = _b === void 0 ? 50 : _b,
      _c = props.showVerticalAfter,
      showVerticalAfter = _c === void 0 ? 4 : _c,
      _d = props.spacingHorizontal,
      spacingHorizontal = _d === void 0 ? 5 : _d,
      _e = props.spacingVertical,
      spacingVertical = _e === void 0 ? 20 : _e,
      style = props.style,
      rest = __rest(props, ["cigarettes", "cigaretteStyle", "fullCigaretteLength", "showMaxCigarettes", "showVerticalAfter", "spacingHorizontal", "spacingVertical", "style"]); // We don't show more than `showMaxCigarettes` cigarettes, and we round to
  // 0.1.


  var cigarettes = api_1.round(Math.max(0.1, Math.min(realCigarettes, showMaxCigarettes)));
  var count = Math.floor(cigarettes); // The cigarette count, without decimal.

  var decimal = cigarettes - count;
  var orientation = cigarettes <= 1 ? 'diagonal' : cigarettes <= showVerticalAfter ? 'horizontal' : 'vertical';
  var baseCigaretteStyle = orientation === 'diagonal' ? undefined : orientation === 'horizontal' ? {
    marginBottom: spacingHorizontal,
    marginRight: spacingVertical
  } : {
    marginBottom: spacingVertical,
    marginRight: spacingHorizontal
  };
  return react_1["default"].createElement(react_native_1.View, __assign({
    style: [styles.innerContainer, style]
  }, rest), cigarettes > 1 && count >= 1 && Array.from(Array(count)).map(function (_, i) {
    return react_1["default"].createElement(Cigarette_1.Cigarette, {
      key: i,
      orientation: orientation,
      percentage: 1,
      fullCigaretteLength: fullCigaretteLength,
      style: [baseCigaretteStyle, cigaretteStyle]
    });
  }), (cigarettes === 1 || decimal > 0) && react_1["default"].createElement(Cigarette_1.Cigarette, {
    orientation: orientation,
    percentage: decimal || 1,
    fullCigaretteLength: fullCigaretteLength,
    style: [baseCigaretteStyle, cigaretteStyle]
  }));
}

exports.Cigarettes = Cigarettes;